import { Vue, Component } from 'vue-property-decorator';
import { Auth } from '../_nav';

type RBAC = {
    auth: Auth;
}

const isValidArray = (a): a is Array<string> => Array.isArray(a) && a.length > 0;

const isValidAuth = (val: any): val is RBAC => {
    return val && val.auth && (isValidArray(val.auth.required) || isValidArray(val.auth.oneOf));
}

@Component
export class authMixin extends Vue {
    public created() {
        if(!isValidAuth(this)){
            console.error('Invalid auth parameter');
        }
        else{
            const auth = this.auth;
            const { required, oneOf } = auth;
            const { mixin_permissions: permissions, } = this;
            if(isValidArray(required)) {
                for(let i = 0; i < required.length; i++){
                    const perm = required[i];
                    if(!permissions[perm]) {
                        this.showError();
                        this.redirect();
                    }
                }
            }
            if(isValidArray(oneOf)) {
                const found = oneOf.find(p => permissions[p]);
                if(!found) {
                    this.showError();
                    this.redirect();
                }
            }
        }
    }

    private showError() {
        this.$toasted.error('Unauthorized access');
    }

    redirect() {
        this.$router.push('/dashboard');
    }

    get mixin_permissions() {
        return this.$store.state.auth.permissions;
    }
}
